import React, { useEffect } from "react";
import Modal from "../../components/modal/modal.component";
import InputComponent from "../../components/input/input.component";
import SwitchComponent from "../../components/switch/switch.component";
import SelectComponent from "../../components/select/select.component";
import Button from "../../components/button/button.component";
import { useForm } from "react-hook-form";
import { to } from "../../polyfill";
import { CustomersService } from "../../services/customers";

function FieldFormModal({ show, data, customer, setShow }: any) {
  const defaultValues = {
    _id: "",
    customer: "",
    name: "",
    hectares: "",
    status: true,
  };

  const {
    watch,
    reset,
    setValue,
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isValid },
  } = useForm<typeof defaultValues>({
    mode: "onChange",
    defaultValues,
  });

  const submit = async (form: typeof defaultValues) => {
    const [error, data] = await to(
      CustomersService.saveField(
        customer._id,
        form.name,
        form._id,
        form.hectares,
        form.status
      )
    );
    if (error) {
      alert(error.message);
    } else {
      setShow(true);
      reset(defaultValues);
    }
  };

  useEffect(() => {
    if (data) {
      setValue('_id', data._id)
      // setValue('customer', customer.name)
      setValue('name', data.name)
      setValue('hectares', data.hectares)
      setValue('status', data.status)
    } else {
      reset({
        ...defaultValues,
        customer: customer.name
      });
    }
  }, [data]);

  return (
    <Modal show={show}>
      <div className="modal-header">
        <h3 className="modal-title">{watch('_id') ? 'Editar': 'Agregar'} huerta</h3>
        <div
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          onClick={setShow}
        >
          <i className="ki-duotone ki-cross fs-1">
            <span className="path1" />
            <span className="path2" />
          </i>
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-5">
          <InputComponent label="Cliente *" {...register('customer', { disabled: true })} />
        </div>

        <div className="mb-5">
          <InputComponent label="Nombre de huerta*" {...register('name', { required: true })} errors={errors.name}/>
        </div>
        <div className="mb-5">
          <InputComponent label="Hectarias" {...register('hectares', { required: false })} errors={errors.hectares}/>
        </div>

        {
          watch('_id') && <SwitchComponent label="Estatus" {...register('status')} errors={errors.status} />
        }
      </div>
      <div className="modal-footer">
        <button className="btn btn-light" type="button" onClick={setShow}>
          Cancelar
        </button>
        <Button
          className="btn btn-primary"
          disabled={!isValid}
          isLoading={isSubmitting}
          onClick={handleSubmit(submit)}
        >
          Guardar
        </Button>
      </div>
    </Modal>
  );
}

export default FieldFormModal;
